<svg-icon [key]="infoIconKey" [class]="colorClass" [size]="size" />
